import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../services/user.service';
import { Level } from '../..//../models/level.model';

@Component({
  selector: 'dialog-admin-set-level',
  templateUrl: './dialogAdminSetLevel.component.html'
})
export class AdminDialogSetLevelComponent {
  public level: number;
  public levels: Level[] = [];

  constructor(private dialogRef: MatDialogRef<AdminDialogSetLevelComponent>, private http: HttpClient, private usrSvc: UserService) {
    this.http.get('/levels').subscribe(
      (resp: Level[]) => {
        this.levels = resp.map(m => new Level(m));
      },
      (err) => {

      }
    );
  }

  public cancel(evt:any) {
    evt.preventDefault();
    this.dialogRef.close();
  }
  public save() {
    // this.http.post(this.level).subscribe(
    //   (player) => this.dialogRef.close(this.level),
    //   (err) => alert(err)
    // )
    this.dialogRef.close(this.level);
  }
}